import { VStack } from 'native-base';
import Tabs from 'ui/components/Tabs';

import { ActivityFormContainer } from '~/components/ActivityFormBuilderPresets/components/ActivityFormContainer';
import { MediaForm } from '~/components/MediaForm';
import Scaffold from '~/components/Scaffold';
import { colors } from '~/theme/colors';

import { AboutForm } from './AboutForm';
import { useActionFormController } from './controller';
import { actionFormTabsElements } from './tabsElements';
import { ActionFormTabsPages } from './types';
import { WhenWhereForm } from './WhenWhereForm';

export const ActionForm = () => {
  const {
    tabsRef,
    currentTab,
    causeOptions,
    formData,
    handleBack,
    handleContinue,
    isLoading,
    onAddedCustomUnit,
    filteredAppsByPermissions,
  } = useActionFormController();

  const renderTabs = () => {
    return {
      [ActionFormTabsPages.About]: (
        <AboutForm
          handleContinue={handleContinue}
          handleBack={handleBack}
          causeOptions={causeOptions}
          defaultValues={formData}
          isLoading={isLoading}
          connectedApps={filteredAppsByPermissions}
          onAddedCustomUnit={onAddedCustomUnit}
        />
      ),
      [ActionFormTabsPages.Media]: (
        <MediaForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          defaultValues={formData}
          isLoading={isLoading}
        />
      ),
      [ActionFormTabsPages.Where]: (
        <WhenWhereForm
          handleBack={handleBack}
          handleContinue={handleContinue}
          defaultValues={formData}
          isLoading={isLoading}
        />
      ),
    }[currentTab];
  };

  return (
    <Scaffold title="Add new action" alignItemsChildren="center">
      <ActivityFormContainer>
        <VStack w="100%" alignItems="center" pb={10}>
          <Tabs
            ref={tabsRef}
            tabBgColor="transparent"
            tabWith="100%"
            tabTextColor={colors.primary['600']}
            tabIndicatorColor={colors.primary['600']}
            tabfocusedTextColor={colors.primary['600']}
            swipeEnabled={false}
            elements={actionFormTabsElements}
            currentTab={currentTab}
          />
        </VStack>
        {renderTabs()}
      </ActivityFormContainer>
    </Scaffold>
  );
};
